import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

interface LocalTimeProps {
    zone: string
    className?: string
}

// Live clock for a studio city. Renders a neutral placeholder on the server and
// fills in after mount, so server and client markup always match.
const LocalTime: FC<LocalTimeProps> = ({ zone, className }): ReactNode => {
    const [time, setTime] = useState<string | null>(null)

    useEffect(() => {
        const format = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: zone
        })

        const update = (): void => setTime(format.format(new Date()))

        update()

        const id = window.setInterval(update, 20000)

        return () => window.clearInterval(id)
    }, [zone])

    return (
        <span className={className}>
            {time ?? '--:--'}
        </span>
    )
}

export default LocalTime
